import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from '.'
import { Sale, SaleActivity } from '../models'

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  constructor(private api: ApiService) {
    // noop
  }

  public get(saleNumber: string): Observable<Sale>{
    return this.api.findAs(
      `invoices/${saleNumber}.json`,
      Sale)
  }

  public significantActivity(id: number): Observable<SaleActivity[]> {
    return this.api.findAllAs(
      `invoices/${id}/activity`,
      { params: { view_mode: 'user', significance: 'high' }},
      SaleActivity)
  }
}
